"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
const filters = ["כל השירותים", "מטפל סיעודי בבית", "השגחה בבית חולים", "ליווי רפואי", "סיוע לאחר ניתוח", "באר שבע והסביבה"];
export default function PortfolioHero() {
  const [activeFilter, setActiveFilter] = useState("כל השירותים");
  return <section data-section-id="256849" id="מטפל-סיעודי-בבאר-שבע-פתרון-מיידי" className="bg-background text-foreground pt-24 pb-12 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000005_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none"></div>

      <div className="page-container relative z-10 flex flex-col">
        {}
        <div className="max-w-4xl">
          <div className="flex items-center gap-4 mb-8">
            <span className="w-8 h-[1px] bg-primary"></span>
            <span className="text-primary text-xs tracking-[0.2em] uppercase font-semibold font-default">
              זמינות מיידית · שירות מקצועי
            </span>
          </div>

          <h1 className="text-5xl md:text-[84px] leading-[1.1] font-bold font-default text-foreground tracking-tight mb-6">
            מטפל סיעודי בבאר שבע תוך 5 שעות.
          </h1>

          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl leading-relaxed font-default">
            זקוקים לעזרה דחופה? אנחנו מספקים פתרונות סיעוד מתקדמים בבירת הנגב. בין אם מדובר ב-מטפל סיעודי בבית או ב-השגחה בבית חולים סורוקה, הצוות שלנו ערוך להגיע אליכם במהירות שיא עם יחס אישי ומקצועי ללא פשרות.
          </p>
        </div>

        {}
        <div className="mt-20 border-y border-border py-6">
          <div className="flex flex-wrap items-center gap-3">
            {filters.map((filter, i) => <Button key={filter} data-index={i} variant={activeFilter === filter ? "default" : "outline"} onClick={() => setActiveFilter(filter)} className={`rounded-lg text-xs tracking-widest uppercase px-6 h-10 transition-colors font-default ${activeFilter === filter ? "bg-primary text-primary-foreground border-primary hover:bg-primary/90 shadow-md" : "bg-transparent text-muted-foreground border-border hover:text-foreground hover:border-primary hover:bg-accent"}`}>
                {filter}
              </Button>)}
          </div>
        </div>
      </div>
    </section>;
}